import ApiService from './index';
const resourceList = '/api/Systems/ListAssetAuctionByCategory';

const Auction = {
  getList(typeId) {
    return ApiService.get(resourceList + '?typeId=' + typeId + '&page=1&pageSize=10');
  },
  getListDone() {
    return ApiService.get('/api/Systems/ListAssetAuctionResult');
  },
  getDetail(id) {
    return ApiService.get('/api/Systems/AuctionDetail?id=' + id);
  },
  getDetailAssetAuction(id) {
    return ApiService.get('/api/Systems/DetailAssetAuction?id=' + id);
  },
  getHistory(id) {
    return ApiService.get('/api/Systems/HistoryAuction?id=' + id);
  },
  payment(body) {
    return ApiService.post(
      '/api/Systems/OnlinePayment?auctionId=' +
        body.auctionId +
        '&userId=' +
        body.userId +
        '&soTaiKhoan=' +
        body.soTaiKhoan +
        '&nganHang=' +
        body.nganHang +
        '&chuTaiKhoan=' +
        body.chuTaiKhoan,
      {},
      {}
    );
  },
  register(body) {
    return ApiService.post('/api/Systems/DangKyThamGiaDauGia', body, {});
  },
  checkRegister(userId, id) {
    return ApiService.get('/api/Systems/CheckDangKyDauGiaId?userId=' + userId + '&lichDauGiaId=' + id);
  },
  play(id, userId, price) {
    return ApiService.post(
      '/api/Systems/PaymentAuctionProduct',
      { LichDauGiaId: Number(id), GiaTra: Number(price), TaiKhoanId: Number(userId) },
      {}
    );
  },
  removePrice(id, userId) {
    return ApiService.post('/api/Systems/RutGiaDaTra', { CuocDauGiaId: Number(id), UserId: Number(userId) }, {});
  },
  removeRegister(id, userId) {
    return ApiService.post('/api/Systems/RutDangKyDauGia', { CuocDauGiaId: Number(id), UserId: Number(userId) }, {});
  },
  removeResult(id, userId) {
    return ApiService.post('/api/Systems/TuChoiTrungDauGia', { CuocDauGiaId: Number(id), UserId: Number(userId) }, {});
  },
  acceptResult(id, userId) {
    return ApiService.post('/api/Systems/ChapNhanTrungGia', { CuocDauGiaId: Number(id), UserId: Number(userId) }, {});
  },
  getListAuction(params) {
    return ApiService.get('/api/Systems/ListAssetAuctionByCategoryPaging', params);
  }
};
export default Auction;



// WEBPACK FOOTER //
// ./src/common/api/auction.js